import { render, staticRenderFns } from "./vatrates.vue?vue&type=template&id=c05381e0&scoped=true&"
import script from "./vatrates.vue?vue&type=script&lang=js&"
export * from "./vatrates.vue?vue&type=script&lang=js&"
import style0 from "./vatrates.vue?vue&type=style&index=0&id=c05381e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05381e0",
  null
  
)

export default component.exports